<app-modal
  [isOpen]="isOpen"
  (close)="onClose()"
  className="max-w-4xl mx-4 sm:mx-6"
>
  @if (bundle) {
    <div class="p-6 sm:p-8">
      <!-- Header -->
      <div class="flex items-start justify-between gap-6 mb-8">
        <div class="flex items-start gap-3">
          @if (bundle.imageUrl) {
            <img
              [src]="bundle.imageUrl"
              [alt]="bundle.name"
              class="w-14 h-14 rounded-lg object-cover"
            />
          }
          <div>
            <div class="flex items-center gap-2 mb-1">
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                {{ bundle.name }}
              </h3>
              <app-badge
                [color]="getActiveColor()"
                size="sm"
                >{{ getActiveLabel() }}</app-badge
              >
            </div>
            <p class="text-xs text-gray-500 dark:text-gray-400 font-mono">
              {{ bundle.sku }}
            </p>
            @if (bundle.description) {
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                {{ bundle.description }}
              </p>
            }
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="border-b border-gray-200 dark:border-gray-700 mb-6">
        <button
          type="button"
          (click)="onTabChange('info')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'info'"
          [class.text-brand-600]="activeTab === 'info'"
          [class.dark:text-brand-400]="activeTab === 'info'"
          [class.border-transparent]="activeTab !== 'info'"
          [class.text-gray-500]="activeTab !== 'info'"
          [class.hover:text-gray-700]="activeTab !== 'info'"
          [class.dark:text-gray-400]="activeTab !== 'info'"
        >
          Información
        </button>
        <button
          type="button"
          (click)="onTabChange('timeline')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'timeline'"
          [class.text-brand-600]="activeTab === 'timeline'"
          [class.dark:text-brand-400]="activeTab === 'timeline'"
          [class.border-transparent]="activeTab !== 'timeline'"
          [class.text-gray-500]="activeTab !== 'timeline'"
          [class.hover:text-gray-700]="activeTab !== 'timeline'"
          [class.dark:text-gray-400]="activeTab !== 'timeline'"
        >
          Línea de tiempo
        </button>
      </div>

      <!-- Content -->

      @if (activeTab === 'info') {
        <div class="space-y-5">
          <!-- Precios -->
          <section>
            <h4
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Precios
            </h4>
            <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
              <div>
                <p class="text-xs text-gray-500">Precio bundle</p>
                <div class="font-semibold text-brand-600 dark:text-brand-400">
                  @if (promoActiva) {
                    <p>
                      {{
                        formatPrecio(
                          bundle.promoPrice,
                          getCurrencyCode(bundle.currencyId)
                        )
                      }}
                    </p>
                  }
                  <p
                    [class.line-through]="promoActiva"
                    [class.text-xs]="promoActiva"
                  >
                    {{
                      formatPrecio(
                        bundle.bundlePrice,
                        getCurrencyCode(bundle.currencyId)
                      )
                    }}
                  </p>
                </div>
              </div>
              <div>
                <p class="text-xs text-gray-500">Dto. %</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{
                    bundle.discountPercent !== undefined &&
                    bundle.discountPercent !== null
                      ? bundle.discountPercent + '%'
                      : '-'
                  }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Calculado</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{
                    precioCalculadoFinal !== undefined
                      ? formatPrecio(
                          precioCalculadoFinal,
                          getCurrencyCode(bundle.currencyId)
                        )
                      : '-'
                  }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Estrategia</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ getPriceStrategyLabel(bundle.priceStrategy) }}
                </p>
              </div>
            </div>
          </section>

          <!-- Configuración -->
          <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h4
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Configuración
            </h4>
            <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
              <div>
                <p class="text-xs text-gray-500">Modo display</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ getDisplayModeLabel(bundle.displayMode) }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Rol</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ getBundleRoleLabel(bundle.bundleRole) }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Moneda</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ getCurrencyCode(bundle.currencyId) }}
                </p>
              </div>
            </div>
          </section>

          <!-- Vigencia promocional (Incidente #57) -->
          <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-2 mb-3">
              <h4
                class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
              >
                Vigencia promocional
              </h4>
              @if (tienePromocion) {
                <app-badge [color]="getPromoStatusColor()" size="sm">{{
                  getPromoStatusLabel()
                }}</app-badge>
              }
            </div>
            @if (!tienePromocion) {
              <p class="text-sm text-gray-500 dark:text-gray-400">
                Este paquete no tiene una promoción configurada.
              </p>
            } @else {
              <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                <div>
                  <p class="text-xs text-gray-500">Precio promocional</p>
                  <p class="font-semibold text-brand-600 dark:text-brand-400">
                    {{
                      formatPrecio(
                        bundle.promoPrice,
                        getCurrencyCode(bundle.currencyId)
                      )
                    }}
                  </p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Desde</p>
                  <p class="text-gray-800 dark:text-gray-200">
                    {{ formatDateOnly(bundle.promoValidFrom) }}
                  </p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Hasta</p>
                  <p class="text-gray-800 dark:text-gray-200">
                    {{ formatDateOnly(bundle.promoValidUntil) }}
                  </p>
                </div>
                <div>
                  <!-- Es el interruptor `promoEnabled`, no el estado: rotularlo
                       "Promoción activa" hacía que la ficha dijera "Inactiva" y
                       "Sí" a la vez. -->
                  <p class="text-xs text-gray-500">Interruptor</p>
                  <p class="text-gray-800 dark:text-gray-200">
                    {{ bundle.promoEnabled === false ? 'No' : 'Sí' }}
                  </p>
                </div>
              </div>
            }
          </section>

          <!-- Items -->
          <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h4
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3"
            >
              Productos del paquete
            </h4>
            @if (loadingItems) {
              <div class="flex justify-center py-6">
                <div
                  class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"
                ></div>
              </div>
            } @else if (bundleItems.length === 0) {
              <p
                class="text-center text-sm text-gray-500 dark:text-gray-400 py-6"
              >
                Sin productos en este paquete.
              </p>
            } @else {
              <div
                class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700"
              >
                <table class="min-w-full text-sm">
                  <thead class="bg-gray-50 dark:bg-gray-800/60">
                    <tr>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400"
                      >
                        Producto
                      </th>
                      <th
                        class="px-3 py-2 text-right text-xs font-medium text-gray-500 dark:text-gray-400"
                      >
                        Cantidad
                      </th>
                      <th
                        class="px-3 py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-400"
                      >
                        Opcional
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100 dark:divide-white/5">
                    @for (it of bundleItems; track it.id) {
                      <tr>
                        <td class="px-3 py-2 text-gray-700 dark:text-gray-300">
                          {{ getProductName(it.idProduct) }}
                        </td>
                        <td
                          class="px-3 py-2 text-right text-gray-700 dark:text-gray-300"
                        >
                          {{ it.quantity }}
                        </td>
                        <td
                          class="px-3 py-2 text-center text-xs dark:text-gray-300"
                        >
                          {{ it.isOptional ? 'Sí' : 'No' }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </section>

          <!-- Metadata -->
          <section class="pt-4 border-t border-gray-200 dark:border-gray-700">
            <h4 class="text-xs font-semibold text-gray-500 uppercase mb-2">
              Metadata
            </h4>
            <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
              <div>
                <p class="text-xs text-gray-500">Productos</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ bundleItems.length }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Creado</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ formatDate(bundle.datetimeCreated) }}
                </p>
              </div>
              <div>
                <p class="text-xs text-gray-500">Actualizado</p>
                <p class="text-gray-800 dark:text-gray-200">
                  {{ formatDate(bundle.datetimeUpdated) }}
                </p>
              </div>
            </div>
          </section>
        </div>
      }

      <!-- ========== TAB: TIMELINE ========== -->
      @if (activeTab === 'timeline') {
        <app-audit-timeline
          [logs]="timelineLogs"
          [loading]="loadingTimeline"
          [error]="timelineError"
          [currentPage]="timelinePage"
          [totalPages]="timelineTotalPages"
          [totalElements]="timelineTotalElements"
          emptyMessage="No hay eventos de auditoría para este negocio."
          (pageChange)="loadTimeline($event)"
        />
      }
      <!-- end timeline tab -->
    </div>
  }
</app-modal>
